import * as React from 'react'

const SvgIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='25'
    fill='none'
    viewBox='0 0 24 25'
    {...props}
  >
    <path
      fill='#1D1D1F'
      fillRule='evenodd'
      d='M16 23.5H7.75A2.75 2.75 0 0 1 5 20.75V4.25A2.75 2.75 0 0 1 7.75 1.5H16a2.75 2.75 0 0 1 2.75 2.75v16.5A2.75 2.75 0 0 1 16 23.5m0-17.875H7.75v13.75H16z'
      clipRule='evenodd'
    ></path>
  </svg>
)

export default SvgIcon
